import {Injectable} from '@angular/core';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {ResponseCodeService} from './response-code.service';
import {MatDialog} from "@angular/material/dialog";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private router: Router,
    private responseCodeService: ResponseCodeService,
    private dialog: MatDialog
  ) {}

  successMessage(message: string, timer = 5000) {
    return Swal.fire({
      title: message,
      text: '',
      icon: 'success',
      allowOutsideClick: true,
      toast: true,
      position: 'bottom-right',
      showConfirmButton: true,
      timerProgressBar: true,
      padding: '20px',
      timer,
    });
  }

  successMessageAndCloseModals(message: string, timer = 5000) {
    this.dialog.closeAll()
    return Swal.fire({
      title: message,
      text: '',
      icon: 'success',
      allowOutsideClick: true,
      toast: true,
      position: 'bottom-right',
      showConfirmButton: true,
      timerProgressBar: true,
      padding: '20px',
      timer,
    });
  }

  errorMessage(message: string) {
    return Swal.fire({
      title: message,
      text: '',
      icon: 'error',
      allowOutsideClick: true,
      toast: true,
      position: 'bottom-right',
      showConfirmButton: false,
      timerProgressBar: true,
      padding: '20px',
      timer: 8000,
    });
  }

  noErrorCode() {
    return Swal.fire({
      title: 'Unknown Error Code Returned',
      text: '',
      icon: 'error',
      position: 'bottom-right',
      allowOutsideClick: false,
    });
  }

  catchError(message: string) {
    return catchError((error) => {
      Swal.fire({
        icon: 'error',
        text: message,
        allowOutsideClick: true,
        toast: true,
        position: 'bottom-right',
        showConfirmButton: false,
        timerProgressBar: true,
        padding: '20px',
        timer: 8000,
      });
      return error;
      // return of([]);
    });
  }

  confirmation(
    message: string = 'Are you sure?',
    confirmButtonText: string = 'Yes'
  ) {
    return Swal.fire({
      title: message,
      // icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28409A',
      cancelButtonColor: '#FF0000',
      confirmButtonText,
      allowOutsideClick: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      },
      customClass: {
        popup : 'swal_class'
      },
    });
  }

  async successMessageWithRedirect(message: string, route: string) {
    const response = await Swal.fire({
      title: message,
      text: '',
      icon: 'success',
      allowOutsideClick: false,
    });
    if (response) {
      return this.router.navigate([route]);
    }
    return false;
  }

  warningMessage(message: string) {
    return Swal.fire({
      title: message,
      text: '',
      icon: 'warning',
      allowOutsideClick: false,
    });
  }




  infoMessage(message: string, timer = 5000) {
    return Swal.fire({
      title: message,
      text: '',
      icon: 'info',
      allowOutsideClick: true,
      toast: true,
      position: 'bottom-right',
      showConfirmButton: false,
      timerProgressBar: true,
      padding: '20px',
      timer,
    });
  }


  handleErrorMessage(data: any) {
    const responseCode = this.responseCodeService.getCodeDescription(
      data?.code
    );
    const message =
      responseCode[0]?.code + ' : ' + responseCode[0]?.description;
    return this.errorMessage(message);
  }

  async warningMessageWithRedired(message: string, route: string) {
    const response = await Swal.fire({
      title: message,
      text: '',
      icon: 'warning',
      allowOutsideClick: false,
    });
    if (response) {
      return this.router.navigate([route]);
    }
    return false;
  }
}
